import { getApprovalRequestSettings } from '@gonfalon/openapi/operations/getApprovalRequestSettings';
import { patchApprovalRequestSettings } from '@gonfalon/openapi/operations/patchApprovalRequestSettings';

import { createMutationHook } from '../internal/createMutationHook';
import { createQueryHook } from '../internal/createQueryHook';
import { createQueryOptions } from '../internal/createQueryOptions';

export const getApprovalRequestSettingsQuery = createQueryOptions(getApprovalRequestSettings);

export const useApprovalRequestSettings = createQueryHook(getApprovalRequestSettingsQuery);
export const useUpdateApprovalRequestSettings = createMutationHook(patchApprovalRequestSettings);
